"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateCustomerOrderItemEvent = exports.Name = void 0;
const Name = exports.Name = 'update-customer-order-item';
const UpdateCustomerOrderItemEvent = exports.UpdateCustomerOrderItemEvent = Name;
//# sourceMappingURL=index.js.map